routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.login', {
      url: "/login",
      template: `<login sh-ctrl="shCtrl"></login>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/login/login.config.js
 **/